// extracted by mini-css-extract-plugin
var _1 = "OctagonalButton__bg--snEDI";
var _2 = "OctagonalButton__border--Tmg5V";
var _3 = "OctagonalButton__button--q_NJC";
var _4 = "OctagonalButton__buttonContent--pI1HX";
var _5 = "OctagonalButton__buttonWrapper--naRCl OctagonalButton__buttonWrapperShared--FUt7p";
var _6 = "OctagonalButton__buttonWrapperNoShadow--sVNcO OctagonalButton__buttonWrapperShared--FUt7p";
var _7 = "OctagonalButton__buttonWrapperShared--FUt7p";
var _8 = "OctagonalButton__image--FCEtD";
var _9 = "OctagonalButton__link--K0xGQ";
var _a = "OctagonalButton__main--hYAJg OctagonalButton__mainBase--lE53E CoreGeneral__buttonBase--ihAxH fontSize__button--bsZDE";
var _b = "OctagonalButton__mainBase--lE53E CoreGeneral__buttonBase--ihAxH";
var _c = "OctagonalButton__octagonSvg--Vo4tT";
var _d = "OctagonalButton__octagonWrapper--RwlVK";
var _e = "OctagonalButton__shadow--NkfXd";
var _f = "OctagonalButton__text--x0MFZ CoreGeneral__robotoSlab--X8lgW";
var _10 = "OctagonalButton__transparent--JcZOS";
export { _1 as "bg", _2 as "border", _3 as "button", _4 as "buttonContent", _5 as "buttonWrapper", _6 as "buttonWrapperNoShadow", _7 as "buttonWrapperShared", _8 as "image", _9 as "link", _a as "main", _b as "mainBase", _c as "octagonSvg", _d as "octagonWrapper", _e as "shadow", _f as "text", _10 as "transparent" }
